module.exports = __webpack_public_path__ + "static/img/lj5.80a4c22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lj5.png
// module id = p2Ya
// module chunks = 3